export enum IconSizes {
  SM = 'sm',
  MD = 'md',
  LG = 'lg'
}
